import { render, staticRenderFns } from "./poltica-privacidade.vue?vue&type=template&id=670d1201&scoped=true&"
import script from "./poltica-privacidade.vue?vue&type=script&lang=js&"
export * from "./poltica-privacidade.vue?vue&type=script&lang=js&"
import style0 from "./poltica-privacidade.vue?vue&type=style&index=0&id=670d1201&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670d1201",
  null
  
)

export default component.exports